module.exports = "/_next/static/images/54024b16b0705c6ecfcc4d77f44c00e4-filter-purple.svg.webp";